module.exports = __webpack_public_path__ + "img/CLS-P-270.e132b8f6.svg";